import { useFindById } from '@/context/SelectComponent/Base';
import { findByName as findByNameUtil } from '@/context/SelectComponent/utils';
import { useGetCrSubItemsAllSuspense } from '@/context/services/cr_sub_items/CrSubItems.service';
import { CrSubItems } from 'ap-openapi';
import { useCallback } from 'react';

export const useFindCrSubItems = () => {
  const items = useGetCrSubItemsAllSuspense();
  const findById = useFindById<CrSubItems, 'id', 'display_name'>(items, {
    key: 'id',
    return: 'display_name',
    defaultVal: '',
  });
  const findByName = useCallback(
    (value: string | undefined, itemId?: string | undefined): string => {
      if (typeof value === 'undefined' || value === '') {
        return '';
      }
      const filteredItems = itemId
        ? items.filter((item) => item.item_id === itemId)
        : items;
      const item = findByNameUtil(filteredItems, value);
      return item?.id || '';
    },
    [items]
  );
  return {
    findCrSubItemsById: findById,
    findCrSubItemsByName: findByName,
  };
};
